var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalWrapperChoice',{attrs:{"option":"glyphReplace"},on:{"confirm":_vm.handleYesClick},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v(" You are about to replace a Glyph ")]},proxy:true}])},[_vm._v(" Replacing a Glyph will restart this "+_vm._s(_vm.resetTerm)+". ")])
}
var staticRenderFns = []

export { render, staticRenderFns }